<template>
  <div>
    <a-row>
      <a-col :span="12">
        <a-descriptions
          title="基本信息"
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="名称">
            {{ profileSupplier.name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人">
            {{ profileSupplier.contact_name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人电话">
            {{ profileSupplier.contact_phone }}
          </a-descriptions-item>

          <a-descriptions-item label="Profile总量">
            {{ profileSupplier.profile_total_count }}
          </a-descriptions-item>

          <a-descriptions-item label="库存量">
            {{ profileSupplier.profile_stock_count }}
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            {{ profileSupplier.remark }}
          </a-descriptions-item>

          <a-descriptions-item label="创建时间">
            {{ profileSupplier.created_at }}
          </a-descriptions-item>

          <a-descriptions-item label="更新时间">
            {{ profileSupplier.updated_at }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findProfileSupplier } from '@/api/profile_supplier'

export default {
  name: 'ShowProfileSupplier',
  data() {
    return {
      profileSupplier: {}
    }
  },
  computed: {
    profileSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findProfileSupplier(this.profileSupplierId).then((res) => {
        if (res.code === 0) {
          this.profileSupplier = res.data
        }
      })
    }
  }
}
</script>
